var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4424 23.7666C10.4424 14.9112 16.9334 7.73242 24.9404 7.73242C32.9475 7.73242 39.4385 14.9112 39.4385 23.7666C39.4385 31.8758 33.9953 38.579 26.9294 39.6511C26.4341 38.2927 25.2309 37.334 23.8252 37.334C21.9774 37.334 20.4795 38.9906 20.4795 41.0342C20.4795 43.0777 21.9774 44.7344 23.8252 44.7344C25.3295 44.7344 26.6019 43.6364 27.023 42.1256C32.1057 41.4275 36.4811 38.2078 39.0937 33.6338H40.5537C44.8652 33.6338 48.3604 29.7683 48.3604 25C48.3604 20.2317 44.8652 16.3662 40.5537 16.3662H40.277C37.6956 9.832 31.8002 5.26562 24.9404 5.26562C18.0807 5.26562 12.1853 9.832 9.60388 16.3662H9.32715C5.01566 16.3662 1.52051 20.2317 1.52051 25C1.52051 29.7683 5.01566 33.6338 9.32715 33.6338H10.8395L10.8432 33.6386H11.9686C12.6272 33.6386 13.0341 32.9203 12.6954 32.3554C11.2688 29.8733 10.4424 26.9286 10.4424 23.7666Z",
    fill: "#EC187B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6346 29.7673L18.1136 29.911L18.1965 29.6345L17.9985 29.4244L17.6346 29.7673ZM16.0186 35.1543L15.5396 35.0106L15.1784 36.2146L16.2679 35.5877L16.0186 35.1543ZM21.1702 32.1897L21.3581 31.7264L21.1321 31.6347L20.9208 31.7563L21.1702 32.1897ZM34.4775 22.8848C34.4775 28.152 30.2076 32.4219 24.9404 32.4219V33.4219C30.7599 33.4219 35.4775 28.7043 35.4775 22.8848H34.4775ZM24.9404 13.3477C30.2076 13.3477 34.4775 17.6176 34.4775 22.8848H35.4775C35.4775 17.0653 30.7599 12.3477 24.9404 12.3477V13.3477ZM15.4033 22.8848C15.4033 17.6176 19.6732 13.3477 24.9404 13.3477V12.3477C19.1209 12.3477 14.4033 17.0653 14.4033 22.8848H15.4033ZM17.9985 29.4244C16.389 27.7166 15.4033 25.4163 15.4033 22.8848H14.4033C14.4033 25.6813 15.4934 28.2242 17.2708 30.1102L17.9985 29.4244ZM16.4975 35.298L18.1136 29.911L17.1557 29.6237L15.5396 35.0106L16.4975 35.298ZM20.9208 31.7563L15.7692 34.7209L16.2679 35.5877L21.4195 32.6231L20.9208 31.7563ZM24.9404 32.4219C23.6725 32.4219 22.4635 32.1747 21.3581 31.7264L20.9822 32.653C22.205 33.149 23.5415 33.4219 24.9404 33.4219V32.4219Z",
    fill: "#383434"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3447,
    cy: 22.75,
    r: 1.01562,
    fill: "#383434"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.376,
    cy: 22.75,
    r: 1.01562,
    fill: "#383434"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4072,
    cy: 22.75,
    r: 1.01562,
    fill: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpContact);
export default __webpack_public_path__ + "static/media/helpContact.4a988b76a911c8550f9b6c8b5fa77de3.svg";
export { ForwardRef as ReactComponent };